<template>
  <v-card width="100%" style="border-radius: 12px; overflow: hidden">
    <v-form @submit.prevent="save" ref="form">
      <v-card-item>
        <v-card-title>{{
          viewType == "edit" ? "Edit" : viewType == "view" ? "View" : "Add"
        }}
          <b>AssessmentCategory</b>
          <v-btn @click="setFalse()" elevation="0" density="comfortable" icon="mdi-close" class="x-closeIcon"></v-btn>
        </v-card-title>
      </v-card-item>
      <v-card-text>
        <v-row no-gutters class="mt-3">
          <v-col cols="12" class="px-0 py-0" style="display: grid">
            <v-radio-group :disabled="showReadOnly" v-model="assessmentCategory.active" inline>
              <v-radio color="primary" label="Active" :value="1"></v-radio>
              <v-radio color="error" label="Inactive" :value="0"></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Input Field -->
          <v-col cols="4">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Code
              <span v-if="!showReadOnly" style="color: #cf0707; padding-left: 2px; font-weight: 700">*</span></v-label>
            <TextFieldComponent density="compact" placeholder="Code" :rules="codeRule" v-model.trim="assessmentCategory.code"
              :disabled="showReadOnly" @keyup="checkCode()" @keydown="prevent($event)" />
            <v-error v-if="codeError">Already Exists!</v-error>
          </v-col>

          <!-- <v-col offset="1">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Status
            </v-label>
              <v-switch v-model="category.active" class="Switch" color="primary"  :disabled="showReadOnly"></v-switch>
          </v-col> -->

          <!-- Input Field -->

          <v-col cols="12">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Name
              <span v-if="!showReadOnly" style="color: #cf0707; padding-left: 2px; font-weight: 700">*</span></v-label>
            <TextFieldComponent density="compact" placeholder="Name" :rules="nameRule" v-model="assessmentCategory.name"
              :disabled="showReadOnly" />
          </v-col>
          <v-col cols="12">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Category
              <span v-if="!showReadOnly" style="color: #cf0707; padding-left: 2px; font-weight: 700">*</span></v-label>
            <EnumAutoComplete density="compact" :showReadOnly="showReadOnly"  placeholder="Department" :selected="assessmentCategory.department" :domain="'DEPARTMENT'"
              @changeEnumData="changeDepartment($event)" :rules="departmentRule"/>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- Cancle And Save Button -->
      <v-card-actions class="mr-3">
        <v-row justify="end" class="dialogBottom" v-if="!showReadOnly">
          <v-btn class="mr-2 cancel" @click="dialog = setFalse()">Cancel</v-btn>
          <v-btn class="save" type="submit">Save</v-btn>
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import AssessmentCategoryService from "@/api/service/AssessmentCategory/AssessmentCategoryService";
import ProjectService from "@/api/service/Project/ProjectService";
import EnumAutoComplete from "@/components/others/EnumAutoComplete.vue";
// import CategoryService from "@/api/service/Category/CategoryService";

export default {
  props: ["id", "viewType", "project_id", "assessmentCategory_id"],
  components: {
    TextFieldComponent,
    EnumAutoComplete
  },

  data() {
    return {
      assessmentCategoryId: [],
      showReadOnly: false,
      assessmentCategoryData: [],
      stageData: [
        { value: "open", display: "Open" },
        { value: "close", display: "Close" },
      ],
      codeRule: [(value) => !!value || "Code is Required."],
      nameRule: [(value) => !!value || "Name is Required."],
      dialog: false,
      type: null,
      codeError: false,
      assessmentCategory: {
        name: null,
        assessmentCategory: null,
        active:1
      },
    };
  },

  watch: {
    id() {
      if (this.id) {
        this.assessmentCategory = {};
        this.getById(this.id);
      }
    },
  },
  created() {
    this.getAssessmentCategoryData();
    if (this.id) {
      this.getById(this.id);
    }
    if (this.viewType) {
      this.showReadOnly = this.viewType == "edit" ? false : true;
    }
  },
  methods: {    
    changeDepartment($value) {
      this.assessmentCategory.department = $value
    },
    prevent(e) {
      if (!/^[a-zA-Z0-9-_ \t]+$/.test(e.key) && e.key !== "Backspace") {
        e.preventDefault();
      }
    },
    checkCode() {
      if (this.assessmentCategory.code && this.assessmentCategory.code.length > 0) {
        this.assessmentCategory.code = this.assessmentCategory.code.toUpperCase();

        AssessmentCategoryService.findAll({ code: this.assessmentCategory.code }).then((res) => {
          let $exist = res.filter((key) => key.code == this.assessmentCategory.code);

          this.codeExistFlag =
            $exist.length > 0
              ? this.assessmentCategory.id && $exist[0].id == this.assessmentCategory.id
                ? false
                : true
              : false;

          if (this.codeExistFlag) {
            this.codeError = true;
          } else {
            this.codeError = false;
          }
        });
      }
    },

    setFalse() {
      this.$emit("closeDialog");
    },
    async getById(id) {
      let res = await AssessmentCategoryService.findOne(id);
      this.assessmentCategory = res[0];
    },
    async getAssessmentCategoryData() {
      let res = await AssessmentCategoryService.findAll();
      this.assessmentCategoryData = res.length > 0 ? res : [];
    },

    async save() {
      let validation = await this.$refs.form.validate();
      if (!validation.valid || this.codeError) {
        console.log("Not valid");
      } else {
        if (this.assessmentCategory.id) {
          await AssessmentCategoryService.save(this.assessmentCategory);
          this.$store.dispatch("setSnackbar", { text: "Updated Successfully" });
          this.dialog = false;
          this.setFalse();
          this.$emit("reload", true);
          this.assessmentCategory = [];
        }
        else {
          try {
            let output = await AssessmentCategoryService.create(this.assessmentCategory);
            console.log(output);
            if (this.project_id) {
              let projectRes = await ProjectService.findOne(this.project_id)
              console.log(projectRes, "kkkkkkkk", projectRes[0].assessmentCategory_id)
              let outputData = projectRes && projectRes[0] && projectRes[0].assessmentCategory_id ? JSON.parse(projectRes[0].assessmentCategory_id) : []
              outputData.push(output.data.data.id)
              console.log(outputData, "hellod")
              projectRes[0].assessmentCategory_id = JSON.stringify(outputData)
              await ProjectService.update(projectRes[0])
            }
            this.$store.dispatch("setSnackbar", { text: "Saved Successfully" });
            this.dialog = false;
            this.setFalse();
            this.$emit("reload", true);
            this.assessmentCategory = [];
          } catch (e) {
            this.$store.dispatch("setSnackbar", {
              color: "error",
              text: "Something Went Wrong",
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
>>>.v-switch .v-selection-control {
  min-height: 0px;
}

</style>
